import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import xss from 'xss';

import { stripLink } from '~/utils/helpers';

const smallTextStyle = css `
  >h2 {
    font-size: 24px;
    font-weight: 500;
    @media(max-width: 700px) {
      font-size: 20px;
    }
  }
  >h3 {
    font-size: 20px;
    font-weight: 500;
    @media(max-width: 700px) {
      font-size: 18px;
    }
  }
  >h4 {
    font-size: 18px;
    font-weight: 500;
    @media(max-width: 700px) {
      font-size: 16px;
    }
  } 
`;

const largeTextStyle = css `
  >p, >ul {
    font-size: 18px;
    font-weight: 400;
    line-height: 1.8;
    @media (max-width: 700px) {
      font-size: 17px;  
    }
  }
  >h2 {
    font-size: 36px;
    font-weight: 500;
    @media (max-width: 700px) {
      font-size: 24px;
    }
  }
  >h3 {
    font-size: 30px;
    font-weight: 500;          
    @media (max-width: 700px) {
      font-size: 22px;
    }
  }
  >h4 {
    font-size: 24px;
    font-weight: 500;          
    @media (max-width: 700px) {
      font-size: 19px;
    }
  }
`;

const TextStyle = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  line-height: 26px;
  > p {
    font-weight: 400;
  }
  ${props => (props.large ? largeTextStyle : smallTextStyle)}
  > ul {
    list-style: initial;
    padding-left: 16px;
  }
`;

const TextTopic = ({ data, fullPath, large }) => {
  return (
    <TextStyle
      large={large}
      dangerouslySetInnerHTML={{ __html: xss(fullPath ? stripLink(data, fullPath) : data) }}
    />
  );
};

TextTopic.propTypes = {
  large: PropTypes.bool,
  fullPath: PropTypes.string,
  data: PropTypes.string,
};

export default TextTopic;
